import React from 'react';
import Markdown from 'markdown-to-jsx';

import { FlexContainer } from 'components/common/FlexContainer';
import { TransparentContainer } from 'components/common/TransparentContainer';
import { Wrapper } from './atoms/Wrapper';
import { Description } from './atoms/Description';

interface Props {
    description: string;
}
export const PageIntroduction: React.FC<Props> = ({ description }) => (
    <FlexContainer>
        <TransparentContainer>
            <Wrapper>
                <Description>
                    <Markdown>{description}</Markdown>
                </Description>
            </Wrapper>
        </TransparentContainer>
    </FlexContainer>
);
